import { get, post } from '.';

export function CreateCommunicationDisposition(options = {}) {
	return post<any>("/app/api/communication_dispositions", options);
}

export function GetCommunicationDispositions(options = {}) {
	return get<any>("/app/api/communication_dispositions", options);
}
